import React from "react";
export const CURRENCIES = {
  MAD: "MAD",
  COINS: "Coins",
};
export const toCurrency = (value = 0, currency = CURRENCIES.COINS) =>
  `${value} ${currency}`;
export const AECurrency = ({
  value = 0,
  currency = CURRENCIES.COINS,
  ...props
}) => {
  // console.log(value)
  return (
    <>
      {value}
      <small>
        <sup className="pl-1">{currency}</sup>
      </small>
    </>
  );
};
